import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/emergency_media/get/${id}`);
  },
  async insert(data) {
    return await http.post('/api/emergency_media/insert', data);
  },
  async update(data) {
    return await http.post('/api/emergency_media/update', data);
  },
  async delete(data) {
    return await http.post('/api/emergency_media/delete', data);
  },
  async getMediaURL(id) {
    return await http.get(`/api/emergency_media/get-media-url/${id}`);
  }
};